export var base_url = "https://readathome.djalim.fr"
